export default "__VITE_ASSET__Sjadcg2q__"